import { ChipsideComponent } from "../chipside-component";

export class MenuDivider extends ChipsideComponent {
	parsedCallback() {
		this.appendChild(document.createElement("hr"));
	}
}